import authRoles from "core/auth/authRoles";
import Verify from "./Verify";

const VerifyConfig = {
  component: Verify,
  path: "/verify-credentials",
  exact: true,
  layout: {
    config: {
      header: {
        display: true,
      },
      sidebar: {
        display: false,
      },
      footer: {
        display: false,
      },
    },
  },
  protected: true,
  auth: authRoles.onlyGuest,
};

export default VerifyConfig;
